import { action } from 'satcheljs';
import type UserOptions from '../store/schema/UserOptions';
import type { EditorServiceModels } from '@editor/client-rest-api';

export const updateSettingsDialogViewState = action(
    'updateSettingsDialogViewState',
    (options: UserOptions) => ({
        options: options,
    })
);

export const updateOverriddenOptionOnSettingsDialogViewState = action(
    'updateOverriddenOptionOnSettingsDialogViewState',
    (overriddenOption: EditorServiceModels.CritiqueTypeOption) => ({
        overriddenOption: overriddenOption,
    })
);

export const updateOverriddenCategoryOnSettingsDialogViewState = action(
    'updateOverriddenCategoryOnSettingsDialogViewState',
    (categoryId: string, enabled: boolean) => ({
        categoryId: categoryId,
        enabled: enabled,
    })
);
